import styled from 'styled-components';
import {
  SELECTORS,
  TABLET_BREAKPOINT,
  PARTNER_GAMES_MOBILE_BREAKPOINT,
  UBISOFT_BLUE
} from '../../constants';




export const PartnerGamesSection = styled.section`
    ${SELECTORS} & {
      display: flex;
      align-items: stretch;
      overflow: hidden;
      width: 100%;
      margin-bottom: 100px;
    }
    
    @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
          display: block;   
        }
    }
  ${SELECTORS} & {
    display: flex;
    align-items: stretch;
    overflow: hidden;
    width: 100%;
  }

  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      display: block;
    }
  }
`;

interface IImageProps {
  side: string;
}

export const ImageContainer = styled.div`
  ${SELECTORS} & {
    flex: 1;
    min-height: 100%;
    position: relative;

    img {
      display: block;
      position: absolute;
      top: 0;
      height: 100%;
      ${({ side }: IImageProps) => side} : 0;
    }
  }

  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      position: unset;
      img {
        position: unset;
      }
    }
  }
`;

export const PartnerGamesTextContainer = styled.div`
  ${SELECTORS} & {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    min-height: 627px;
    flex: 0 0 46%;
    margin: auto;
  }
  @media (max-width: 1500px) {
    ${SELECTORS} & {
      flex: 0 0 54%;
      min-height: 421px;
    }
  }

  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      justify-content: left;
      width: 90%;
      min-height: unset;
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
`;

export const PartnerGamesTitle = styled.h1`
  ${SELECTORS} & {
    text-align: center;
  }
  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      text-align: left;
    }
  }
`;

export const PartnerGameTagContainer = styled.div`
  ${SELECTORS} & {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 20px auto;
  }

  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      justify-content: left;
      margin: 15px auto;
    }
  }
`;

interface ITagProps {
  tagColor: string;
  firstTag: boolean;
}

export const PartnerGameTag = styled.p`
  ${SELECTORS} & {
    text-align: center;
    margin: 10px ${({ firstTag }: ITagProps) => (firstTag ? '10px' : '0px')}
      10px 0;
    background: ${({ tagColor }: ITagProps) => tagColor};
    width: fit-content;
    border-radius: 40px;
    padding: 5px 20px;
    font-size: 14px;
    line-height: 114%;
    font-family: ${props => props.theme.boldFont};
    font-weight: ${props => props.theme.fontWeight};
  }
`;

export const PartnerGameDescription = styled.p`
  ${SELECTORS} & {
    width: 80%;
    text-align: center;
    margin-bottom: 30px;
  }
  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      width: 100%;
      text-align: left;
      margin-bottom: 15px;
    }
  }
`;

interface ICloudTags {
  singleCloudItem: boolean;
}

export const ViewCloudGamesContainer = styled.div`
  ${SELECTORS} & {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
  }
  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      justify-content: ${({ singleCloudItem }: ICloudTags) => (singleCloudItem ? 'center' : 'left')};
    }
  }
`;

interface ICloudItem {
    clicked: boolean;
    singleItem: boolean;
    firstItem: boolean;
}

export const ViewCloudGamesItem = styled.div`
  ${SELECTORS} & {
    width: ${({ singleItem }: ICloudItem) => (singleItem ? '500px' : ' auto')};
    border: 3px solid
      ${({ clicked }: ICloudItem) => (clicked ? 'white !important' : '#3c4145')};
    flex-direction: ${({ singleItem }: ICloudItem) =>
      singleItem ? 'row' : 'column'};
    border-radius: 5px;
    background: #3c4145;
    padding: 15px 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ singleItem }: ICloudItem) =>
      singleItem ? 'space-between' : ' center'};
    align-content: center;
    margin: 0 5px 10px 5px;
    cursor: pointer;
    transition: border 150ms ease-out;

    svg {
      margin: ${({ singleItem }: ICloudItem) =>
        singleItem ? 'auto 0' : '0 auto 10px auto'};
      height: 36px;
    }

    &:hover {
      border-color: ${UBISOFT_BLUE};
    }
  }

  @media (max-width: ${TABLET_BREAKPOINT}) {
    ${SELECTORS} & {
      width: ${({ singleItem }: ICloudItem) => (singleItem ? '500px' : ' 48%')};
    }
  }

  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      width: ${({ singleItem }: ICloudItem) => (singleItem ? '80%' : ' 48%')};
      justify-content: center;
      margin: 0 ${({ firstItem }: ICloudItem) => (firstItem ? '10px' : '0')}
        10px 0;
      svg {
        max-width: 100%;
        height: 21px;
      }
    }
  }
`;

export const CloudSeparator = styled.div`
  ${SELECTORS} & {
    height: 45px;
    border: 1px solid #ffffff;
  }
  @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
    ${SELECTORS} & {
      display: none;
    }
  }
`;


interface singleItemCloudGameLink  {
    singleItem : boolean;
}
export const ViewCloudGamesItemLink = styled.a`
    ${SELECTORS} & {
      text-decoration: underline;
      text-align: center;
      height: fit-content;
      margin: auto 0;
      font-size: 21px;
      line-height: 24.8px;
      font-family: ${props => props.theme.font};
      font-weight: ${props => props.theme.fontWeight};
      
      &:hover {
          color: white;
      }
      @media (max-width: ${TABLET_BREAKPOINT}) {
          font-size: 16px;
          line-height: 19.2px;
      }
      
      @media (max-width: ${PARTNER_GAMES_MOBILE_BREAKPOINT}) {
        width: ${({ singleItem }: singleItemCloudGameLink) => (singleItem ? '100%' : 'auto')};
      }
    }
    
`;
